import { logError } from 'util/errors';
import services from 'api/services';

import {
  LOAD_REPORT_REQUEST,
  LOAD_REPORT_SUCCESS,
  LOAD_REPORT_FAILURE,
  UPDATE_TICKET_DEPARTMENT_REQUEST,
  UPDATE_TICKET_DEPARTMENT_SUCCESS,
  UPDATE_TICKET_DEPARTMENT_FAILURE,
} from './constants';

const { TicketService } = services;

export const loadReport = (id, isDownload) => async (dispatch) => {
  try {
    dispatch({ type: LOAD_REPORT_REQUEST });
    const response = await TicketService.loadReport(id, isDownload);
    dispatch({ type: LOAD_REPORT_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: LOAD_REPORT_FAILURE, error: ex.message });
  }
};

export const updateTicketDepartment = (ticketId, departmentId) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_TICKET_DEPARTMENT_REQUEST });
    const ticket = await TicketService.updateTicketDepartment(ticketId, departmentId);
    dispatch({ type: UPDATE_TICKET_DEPARTMENT_SUCCESS, data: ticket });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_TICKET_DEPARTMENT_FAILURE, error: ex.message });
  }
};
